import { CreateEditInvoiceTemplateForm } from './CreateEditInvoiceTemplateForm';

export const CreateInvoiceTemplate = () => {
  return <CreateEditInvoiceTemplateForm invoiceTemplate={null} mode="create" />;
};
